import { $ } from '@/Engine/state';
import { Object3D, Event } from 'three';
import { IV3D } from '@/Interfaces/v3d';
import { Part } from '@/Engine/Part';
import { useStoreUI } from '@/Store/storeUI';
import { _raycaster, getPointerCoords, setRaycasterFromCamera } from '@/Engine/eventHandlers/libs/raycaster';
import { Drawer } from '@/Engine/Drawer';
import { shelfCNCHard } from '@/Engine/shelfCNCHard';

declare let v3d: IV3D;

export function initDown(event: MouseEvent) {
    setRaycasterFromCamera(event);
    $.positionStartPointer = getPointerCoords();
    if (!$.positionStartPointer) return;
    $.pointerVirtual = $.positionStartPointer.clone();
    $.down = true;
    $.up = false;
    $.moved = false;
}

//все что в sortIntersects должно иметь меньший приоритет, чем остальное
export const sortIntersects = [ 'set_niches_tc_1995' ];

export function getSortIntersects(objUp) {
    const endObj: Part|Drawer|shelfCNCHard[] = [];
    const obj = objUp?.map((x: Part|Drawer|shelfCNCHard) => {
        if (x.model?.name == 'shelf_chpu_hard') {
            return x?.model?.parent?.userData?.parent;
        }
        if (!sortIntersects.includes(x.model?.name)) {
            return x;
        }
        endObj.push(x);
    });
    objUp = obj.concat(endObj);
    // для экранов самый приоритетный(верхний)
    if (objUp[0]?.key === 'shield') {
        return objUp?.sort((a: Part, b: Part) => b.isPriorityIndex - a.isPriorityIndex);
    }
    return objUp;
}

export const onMouseDownHandler = (event: MouseEvent): void => {
    if (!$.toolChest) return;
    initDown(event);
    // задаем $.selectedModel
    const raycastBoxes: Array<Object3D> = $.toolChest.parts?.map((item: Part) => item.model);
    $.selectedModel?.userData.parent.unselect();
    const intersects = _raycaster.intersectObjects(raycastBoxes, true);

    // Самый ближний по distance
    let objUp = intersects.map(item => {
        //какие-то элементы могут быть не Mesh, а группой(объединением нескольких Mesh,например lateral_screen_ms)
        //поэтому нужно подняться на уровень выше
        if (!item.object?.parent?.userData.parent) return item.object?.parent?.parent?.userData.parent;
        return item.object?.parent?.userData.parent;
    });

    objUp = getSortIntersects(objUp);

    const nearestIntersection: Part | null = intersects.length > 0 ? objUp[0] : null;
    if (!nearestIntersection) {
        $.render();
        return;
    }
    $.ctrlKey = event.ctrlKey;
    $.toolChest.parts.forEach(x => {
        if (nearestIntersection?.id == x.id) {
            x.select();
        }
    });
    useStoreUI().setDndItem($.selectedModel?.userData.parent.prototypeId, false);
    $.render();
};



// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const computePointerPosition = (containerParent?: HTMLElement, e: Event|MouseEvent) => {
    const pointer = new v3d.Vector2();
    if (!containerParent) return pointer;
    const viewportOffset = containerParent.getBoundingClientRect();
    const top = viewportOffset.top;
    const left = viewportOffset.left;
    pointer.x =
        ((e.clientX - left) / containerParent.offsetWidth) * 2 - 1;
    pointer.y =
        -((e.clientY - top) / containerParent.offsetHeight) * 2 + 1;
    return pointer;
};
